module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/extend.js
// module id = 205
// module chunks = 0